module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("课程列表")]), _vm._v(" "), _c('group', {
    attrs: {
      "gutter": "0"
    }
  }, _vm._l((_vm.courseInstances), function(courseInstance) {
    return _c('cell', {
      key: courseInstance.id,
      attrs: {
        "title": courseInstance.course.name,
        "inline-desc": courseInstance.teacher.name,
        "link": ("/course/" + (courseInstance.id))
      }
    }, [_c('span', [_vm._v(_vm._s(courseInstance.homework_count || ''))])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c219c9b"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CourseList.vue
// module id = 557
// module chunks = 1